var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","aria-label":"Powrót"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',[_vm._v("mdi-arrow-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }